export const rankingItems = [
  { rank: 1, title: '长安三万里', meta: '热度 986万 · 动画史诗', tag: '新上榜', tagColor: 'accent' },
  { rank: 2, title: '流浪地球2', meta: '热度 872万 · 科幻巨制', tag: '热播中', tagColor: 'primary' },
  { rank: 3, title: '封神第一部', meta: '热度 765万 · 神话史诗', tag: '飙升', tagColor: 'accent' },
  { rank: 4, title: '孤注一掷', meta: '热度 698万 · 犯罪悬疑', tag: '推荐', tagColor: 'secondary' },
  { rank: 5, title: '消失的她', meta: '热度 623万 · 悬疑反转', tag: '热门', tagColor: 'primary' },
  { rank: 6, title: '八角笼中', meta: '热度 541万 · 现实题材', tag: '好评', tagColor: 'secondary' },
  { rank: 7, title: '满江红', meta: '热度 487万 · 古装悬疑', tag: '经典', tagColor: 'secondary' },
];

export const aboutContent = {
  title: '关于琪琪影院',
  description: '琪琪影院自成立以来，始终致力于为用户提供高清影视蓝光画质的在线观影体验。依托领先的不缓冲播放技术，我们打造了一个覆盖电影、电视剧、综艺、动漫、纪录片等全品类的高清影视平台。',
  highlights: [
    { icon: 'ri-movie-2-line', label: '海量片库', value: '超 30,000 部影视资源覆盖全球热门作品' },
    { icon: 'ri-4k-line', label: '蓝光画质', value: '支持 1080P 至 4K 超清画质在线即点即播' },
    { icon: 'ri-speed-up-line', label: '不缓冲播放', value: '自研加速引擎确保播放零等待流畅观影' },
  ],
};

export const commentItems = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Chinese%20woman%20in%20her%2020s%20with%20warm%20smile%20on%20simple%20neutral%20background%20soft%20natural%20lighting&width=120&height=120&seq=avatar-cmt-01&orientation=squarish',
    name: '小橘子',
    date: '3 天前',
    content: '琪琪影院的画质真的太赞了！蓝光画质看起来跟电影院一样清晰，而且完全没有缓冲，看《长安三万里》全程不卡顿，体验比别的平台好太多了。',
    film: '长安三万里',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Chinese%20man%20in%20his%2030s%20with%20friendly%20expression%20on%20simple%20neutral%20background%20soft%20natural%20lighting&width=120&height=120&seq=avatar-cmt-02&orientation=squarish',
    name: '影迷阿杰',
    date: '5 天前',
    content: '每天都在琪琪影院追剧，更新速度超级快，新片上线基本上全网同步。不缓冲播放技术真的厉害，用手机数据流量看都流畅得不行。',
    film: '流浪地球2',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Chinese%20woman%20with%20bright%20smile%20on%20simple%20neutral%20background%20soft%20natural%20lighting&width=120&height=120&seq=avatar-cmt-03&orientation=squarish',
    name: '追剧小能手',
    date: '1 周前',
    content: '朋友推荐的琪琪影院，真的是一用就回不去了！超清视频全部免费看，资源也特别全，想看的国产剧海外剧都能找到，已经成为我的主力观影平台了。',
    film: '封神第一部',
  },
];

export const topicItems = [
  { name: '国产动画崛起', heat: '128万讨论', href: '#ranking' },
  { name: '科幻大片合集', heat: '96万讨论', href: '#carousel' },
  { name: '悬疑烧脑推荐', heat: '85万讨论', href: '#cards' },
  { name: '暑期档必看', heat: '74万讨论', href: '#index' },
  { name: '4K蓝光专区', heat: '63万讨论', href: '#features' },
  { name: '高分华语片', heat: '58万讨论', href: '#ranking' },
  { name: '不缓冲黑科技', heat: '47万讨论', href: '#features' },
  { name: '家庭观影清单', heat: '42万讨论', href: '#cards' },
  { name: '新片速递', heat: '39万讨论', href: '#updates' },
  { name: '经典重温', heat: '35万讨论', href: '#carousel' },
];

export const contactInfo = {
  title: '联系我们',
  subtitle: '商务合作、版权咨询、内容投稿，我们期待与您交流',
  items: [
    { icon: 'ri-mail-line', label: '商务邮箱', value: 'business@qiqicinema.com' },
    { icon: 'ri-customer-service-2-line', label: '在线客服', value: '工作日 9:00 - 21:00' },
    { icon: 'ri-wechat-line', label: '官方微信', value: '搜索"琪琪影院"关注我们' },
  ],
};

export const indexItems = [
  { title: '动作冒险', desc: '肾上腺素飙升的热门动作大片', count: '2,186部', icon: 'ri-fire-line' },
  { title: '科幻奇幻', desc: '脑洞大开的视觉奇观盛宴', count: '1,534部', icon: 'ri-rocket-line' },
  { title: '悬疑推理', desc: '层层反转烧脑不停', count: '1,892部', icon: 'ri-search-eye-line' },
  { title: '喜剧搞笑', desc: '笑到停不下来的欢乐时光', count: '3,120部', icon: 'ri-emotion-laugh-line' },
  { title: '爱情文艺', desc: '温暖治愈的情感故事', count: '2,456部', icon: 'ri-heart-line' },
  { title: '恐怖惊悚', desc: '胆量挑战者专属区域', count: '1,038部', icon: 'ri-ghost-line' },
  { title: '纪录纪实', desc: '真实世界的精彩呈现', count: '876部', icon: 'ri-camera-line' },
  { title: '动画动漫', desc: '国漫日漫美漫全覆盖', count: '4,520部', icon: 'ri-paint-brush-line' },
  { title: '综艺娱乐', desc: '热播综艺随时追更', count: '1,640部', icon: 'ri-tv-line' },
];

export const featureItems = [
  {
    icon: 'ri-4k-line',
    title: '蓝光画质',
    desc: '从1080P到4K超清画质自由切换，HDR加持每一帧都是视觉享受，在家也能享受影院级观影体验。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '不缓冲播放',
    desc: '自研P2P加速引擎与全球CDN节点，即点即播零等待，告别加载转圈圈，流畅观影全程无忧。',
  },
  {
    icon: 'ri-global-line',
    title: '海量片库',
    desc: '覆盖全球热门影视资源，国产剧、美剧、韩剧、日漫一网打尽，每周持续更新优质内容。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全终端适配',
    desc: '电脑、平板、手机多端同步，WiFi与移动网络智能切换，随时随地畅享超清视频体验。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全无广告',
    desc: '纯净观影环境，无弹窗无恶意跳转，严格内容审核机制保障青少年健康观影。',
  },
];

export const mediaItems = [
  {
    title: '暑期档Top10必看电影盘点',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20collage%20with%20warm%20golden%20accents%20film%20reel%20texture%20dramatic%20lighting%20poster%20style%20composition%20on%20dark%20background&width=600&height=340&seq=media-cover-01&orientation=landscape',
    duration: '08:24',
    views: '126万',
  },
  {
    title: '蓝光画质对比：4K vs 1080P有多大区别',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20comparison%20split%20screen%20showing%20high%20definition%20movie%20scene%20with%20rich%20contrast%20and%20detail%20on%20dark%20background&width=600&height=340&seq=media-cover-02&orientation=landscape',
    duration: '12:56',
    views: '89万',
  },
  {
    title: '国产科幻电影崛起之路特辑',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20science%20fiction%20film%20aesthetic%20with%20futuristic%20city%20silhouette%20warm%20golden%20and%20dark%20tones%20cinematic%20atmosphere&width=600&height=340&seq=media-cover-03&orientation=landscape',
    duration: '15:30',
    views: '203万',
  },
  {
    title: '悬疑片爱好者必看的烧脑神作',
    cover: 'https://readdy.ai/api/search-image?query=Mysterious%20shadowy%20cinematic%20scene%20with%20silhouette%20and%20warm%20dramatic%20lighting%20thriller%20atmosphere%20dark%20aesthetic%20film%20noir%20style&width=600&height=340&seq=media-cover-04&orientation=landscape',
    duration: '10:15',
    views: '157万',
  },
  {
    title: '经典动画电影的幕后制作花絮',
    cover: 'https://readdy.ai/api/search-image?query=Animated%20film%20storyboard%20and%20character%20design%20with%20warm%20artistic%20lighting%20behind%20the%20scenes%20creative%20studio%20atmosphere%20on%20dark%20background&width=600&height=340&seq=media-cover-05&orientation=landscape',
    duration: '06:48',
    views: '94万',
  },
];

export const cardItems = [
  {
    title: '长安三万里：一部写给盛唐的情书',
    excerpt: '追光动画十年磨一剑，用诗意画面再现大唐风华。168分钟的时长里，李白与高适的友谊穿越数十载，让观众在绝美的水墨动画中感受盛唐气象与诗人的浪漫豪情。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20poetic%20landscape%20with%20warm%20golden%20sunset%20light%20traditional%20architecture%20silhouettes%20cinematic%20atmosphere%20dark%20moody%20background&width=800&height=450&seq=card-img-01&orientation=landscape',
    tag: '深度影评',
    date: '2026-07-28',
  },
  {
    title: '流浪地球2幕后：中国科幻工业的里程碑',
    excerpt: '从行星发动机到太空电梯，每一个特效镜头背后都是中国电影人的匠心。郭帆导演带领团队将国产科幻推向了前所未有的高度，蓝光画质下每一帧都经得起放大审视。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20space%20station%20and%20planetary%20engine%20concept%20art%20with%20warm%20orange%20glow%20against%20dark%20space%20cinematic%20sci-fi%20atmosphere&width=800&height=450&seq=card-img-02&orientation=landscape',
    tag: '幕后揭秘',
    date: '2026-07-25',
  },
  {
    title: '封神第一部：神话史诗的现代重构',
    excerpt: '乌尔善导演用十年筹备打造了这部华语神话史诗。纣王与妲己的角色塑造突破传统印象，宏大的战争场面与精致的服化道在超清画质下震撼呈现。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20battle%20scene%20with%20ancient%20warriors%20in%20golden%20armor%20dramatic%20clouds%20and%20warm%20cinematic%20lighting%20dark%20atmosphere&width=800&height=450&seq=card-img-03&orientation=landscape',
    tag: '新片解读',
    date: '2026-07-22',
  },
  {
    title: '孤注一掷：现实题材的票房奇迹',
    excerpt: '这部聚焦境外网络诈骗的犯罪片以真实震撼的叙事斩获超高票房。张艺兴、金晨的突破性表演让观众在紧张刺激中感受到强烈的现实警示意义。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20tense%20urban%20night%20scene%20with%20neon%20signs%20and%20shadows%20crime%20thriller%20atmosphere%20cinematic%20composition%20with%20warm%20red%20accents&width=800&height=450&seq=card-img-04&orientation=landscape',
    tag: '热片分析',
    date: '2026-07-20',
  },
  {
    title: '消失的她：反转叙事的教科书级示范',
    excerpt: '陈思诚监制的这部悬疑片以多层嵌套的反转结构刷新了观众对国产悬疑的认知。朱一龙、倪妮的精湛演技配合紧凑叙事，让每一个细节都暗藏玄机。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20tropical%20ocean%20scene%20at%20twilight%20with%20dramatic%20clouds%20and%20warm%20golden%20light%20cinematic%20thriller%20atmosphere%20dark%20moody%20background&width=800&height=450&seq=card-img-05&orientation=landscape',
    tag: '悬疑解析',
    date: '2026-07-18',
  },
  {
    title: '八角笼中：王宝强的导演蜕变之作',
    excerpt: '从喜剧演员到严肃导演，王宝强用这部现实题材作品证明了自己的创作深度。大山里的格斗少年故事朴实有力，朴素镜头下是对底层命运的深情关怀。',
    image: 'https://readdy.ai/api/search-image?query=Rustic%20mountain%20landscape%20with%20warm%20golden%20sunset%20light%20simple%20rural%20scene%20cinematic%20documentary%20style%20composition%20dark%20natural%20atmosphere&width=800&height=450&seq=card-img-06&orientation=landscape',
    tag: '导演特写',
    date: '2026-07-15',
  },
];

export const carouselItems = [
  {
    title: '2026暑期档观影指南',
    subtitle: '精选30部必看新片，从国产大片到海外佳作',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20movie%20marquee%20with%20warm%20golden%20lights%20and%20dark%20theater%20atmosphere%20film%20posters%20collage%20dramatic%20composition&width=900&height=500&seq=carousel-01&orientation=landscape',
    tag: '编辑精选',
    href: '#ranking',
  },
  {
    title: '不缓冲播放技术全面升级',
    subtitle: '全新P2P加速引擎上线，4K视频秒开不卡顿',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20technology%20concept%20with%20glowing%20data%20streams%20and%20warm%20orange%20light%20on%20dark%20background%20cinematic%20tech%20atmosphere&width=900&height=500&seq=carousel-02&orientation=landscape',
    tag: '技术前沿',
    href: '#features',
  },
  {
    title: '国产动画电影黄金时代',
    subtitle: '从大圣归来到长安三万里，国漫崛起之路',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20style%20with%20ink%20wash%20painting%20aesthetic%20warm%20golden%20and%20dark%20tones%20cinematic%20composition%20traditional%20elements&width=900&height=500&seq=carousel-03&orientation=landscape',
    tag: '专题策划',
    href: '#cards',
  },
  {
    title: '蓝光画质观影体验大横评',
    subtitle: '主流平台画质对比，琪琪影院蓝光技术解析',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20home%20theater%20setup%20with%20warm%20ambient%20lighting%20large%20screen%20displaying%20vibrant%20movie%20scene%20dark%20luxurious%20room%20atmosphere&width=900&height=500&seq=carousel-04&orientation=landscape',
    tag: '深度测评',
    href: '#features',
  },
  {
    title: '每周新片速递：7月第5周',
    subtitle: '10部最新上线影片，涵盖动作悬疑喜剧动画',
    image: 'https://readdy.ai/api/search-image?query=Film%20reels%20and%20cinema%20tickets%20with%20warm%20vintage%20golden%20lighting%20dark%20nostalgic%20atmosphere%20movie%20theater%20aesthetic&width=900&height=500&seq=carousel-05&orientation=landscape',
    tag: '每周更新',
    href: '#updates',
  },
];

export const updateItems = [
  {
    date: '2026-07-30',
    title: '《长安三万里》4K蓝光修复版独家上线',
    type: '上新',
    typeColor: 'accent' as const,
  },
  {
    date: '2026-07-28',
    title: '不缓冲播放引擎v3.2更新，移动端体验大幅优化',
    type: '系统',
    typeColor: 'primary' as const,
  },
  {
    date: '2026-07-25',
    title: '暑期档专题"国产动画黄金时代"正式上线',
    type: '专题',
    typeColor: 'secondary' as const,
  },
  {
    date: '2026-07-22',
    title: '新增韩剧专区，首批上线200+热门韩剧高清资源',
    type: '上新',
    typeColor: 'accent' as const,
  },
  {
    date: '2026-07-20',
    title: '播放器界面全新改版，支持自定义字幕样式',
    type: '更新',
    typeColor: 'primary' as const,
  },
  {
    date: '2026-07-18',
    title: '《流浪地球2》导演剪辑加长版超清上线',
    type: '上新',
    typeColor: 'accent' as const,
  },
  {
    date: '2026-07-15',
    title: '家庭模式功能上线，自动过滤不适合儿童的内容',
    type: '功能',
    typeColor: 'secondary' as const,
  },
  {
    date: '2026-07-12',
    title: '海外CDN节点扩容，全球观影流畅度提升40%',
    type: '系统',
    typeColor: 'primary' as const,
  },
  {
    date: '2026-07-10',
    title: '暑期档片单公布，50+新片陆续上线中',
    type: '公告',
    typeColor: 'accent' as const,
  },
];

export const appContent = {
  title: '随时随地 流畅观影',
  subtitle: '下载琪琪影院移动客户端，蓝光画质随身享，离线缓存免流量',
  features: ['蓝光画质离线下载', '手机流量智能省流', '投屏电视大屏观看', '新片上线推送提醒'],
};

export const faqItems = [
  {
    q: '琪琪影院的蓝光画质需要付费吗？',
    a: '不需要。琪琪影院所有影视资源均支持免费在线观看，包括1080P和4K蓝光画质。您只需注册账号即可享受超清视频画质，平台通过不缓冲播放技术确保流畅观影体验，全程无任何收费项目。',
  },
  {
    q: '不缓冲播放技术是如何实现的？',
    a: '琪琪影院采用自研的P2P加速引擎与全球分布式CDN节点协同工作。当您点播视频时，系统会自动选择最优节点传输数据，同时智能预加载后续片段，实现即点即播的无等待体验。即使网络波动也能保持播放流畅不卡顿。',
  },
  {
    q: '支持哪些设备观看高清影视？',
    a: '琪琪影院全面适配电脑（Windows/Mac）、平板（iPad/Android）、手机（iOS/Android）以及智能电视和投影仪。同一账号多终端同步观看进度，从通勤路上的手机到客厅的电视大屏，随时随地无缝切换流畅观影。',
  },
  {
    q: '影片资源多久更新一次？',
    a: '琪琪影院保持每日更新频率。新上映的热门影片通常在院线下映后2-4周内上线高清版本；电视剧和综艺节目一般在播出后24小时内同步更新；经典老片和海外资源也会根据用户需求持续扩充，确保海量影视资源即时点播。',
  },
];